export interface WicketUser {
  birthday?: string;
  building_number?: string;
  city?: string;
  document_number?: string;
  flat_number?: string;
  id?: string;
  nickname?: string;
  street?: string;
  email: string | undefined;
  first_name?: string;
  last_name?: string;
  profile_photo?: string;
  is_club?: string;
  club_id?: number;
  pesel?: string;
  preferred_language?: 'pl' | 'en' | 'lt' | 'pt' | 'fr' | '';
  last_login?: string;
  provider_name?: string;
  created_at?: string;
}
